import { useState, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useDebounce } from 'use-debounce';
import Skeleton from "@components/new/Skeleton";
import TextInput from "@components/TextInput/TextInput";
import {
  searchItems,
  TUnknownItem,
  TRequestItem,
} from "@api/apiClient/fbp";

const ItemSearchItem = ({ data, onSuccess, sellerWarehouseId }: {
  sellerWarehouseId: string;
  data: TUnknownItem;
  onSuccess: (v: TRequestItem) => void;
}): ReactElement => {
  const { t } = useTranslation();
  const [isPristine, setIsPristine] = useState<boolean>(true);
  // const [error, setError] = useState<boolean>(true);
  const [searchString, setSearchString] = useState<string>(data.sku ?? "")
  const [activeSearchString] = useDebounce(isPristine ? "" : searchString, 500);

  const request = useQuery({
    queryKey: ["fbp-searchItems", activeSearchString],
    queryFn: () => searchItems({
      sellerWarehouseId,
      search: searchString,
    }),
    enabled: !isPristine && activeSearchString.length >= 3,
    retry: 1,
    onSuccess: (res) => {
      if (res.length === 1) {
        onSuccess({ ...res[0], count: data.count || 1 });
      }
    }
  });

  if (request.isFetching) {
    return (
      <Skeleton width="100%" height="39px" />
    );
  }

  return (
    <TextInput
      value={searchString}
      onChange={(v) => {
        setSearchString(v);
        setIsPristine(false);
      }}
      type="text"
      hasError
      errorMessage={t("fbpPage.createOrder.declineReasons.notFound")}
    />
  );
};

export default ItemSearchItem;
